import {
  RedoMarketplaceProductFieldType,
  RedoMarketplaceVariantFieldType,
} from "@redotech/redo-prisma-client/enums";
import * as z from "zod/v4";
import { attributeDefinitionIdFormat } from "../../ids";

const RedoMarketplaceProductMappingSchema_ = z.object({
  fieldName: z.enum(RedoMarketplaceProductFieldType),
  attributeDefinitionId: attributeDefinitionIdFormat.schema,
});
export const RedoMarketplaceProductMappingSchema: z.ZodType<RedoMarketplaceProductMapping> =
  RedoMarketplaceProductMappingSchema_;
export interface RedoMarketplaceProductMapping
  extends z.infer<typeof RedoMarketplaceProductMappingSchema_> {}

const RedoMarketplaceVariantMappingSchema_ = z.object({
  fieldName: z.enum(RedoMarketplaceVariantFieldType),
  attributeDefinitionId: attributeDefinitionIdFormat.schema,
});
export const RedoMarketplaceVariantMappingSchema: z.ZodType<RedoMarketplaceVariantMapping> =
  RedoMarketplaceVariantMappingSchema_;
export interface RedoMarketplaceVariantMapping
  extends z.infer<typeof RedoMarketplaceVariantMappingSchema_> {}

export const RedoMarketplaceMappingSchema_ = z.object({
  productMappings: z.array(RedoMarketplaceProductMappingSchema).readonly(),
  variantMappings: z.array(RedoMarketplaceVariantMappingSchema).readonly(),
});
export const RedoMarketplaceMappingSchema: z.ZodType<RedoMarketplaceMapping> =
  RedoMarketplaceMappingSchema_;
export interface RedoMarketplaceMapping
  extends z.infer<typeof RedoMarketplaceMappingSchema_> {}
